import Base from 'front/components/Base/Base';
import Urls from 'django_js_front/reverse.js';
import * as _ from 'underscore';

import {VIEWPORT_EVENTS} from '../../../constants/Constants';
import './TopBar.less';
import SearchItem from 'front/components/Common/SearchItem/SearchItem';
import SearchItemTemplate from 'front/components/Common/SearchItem/SearchItemFrontendRendering.jinja';
import axios from 'axios';

const Selectors = {
    el: '.TopBar',
    search: '.TopBar-search',
    mobileSearch: '.TopBar-mobileSearch',
    inputSearch: 'input',
    popupSearch: '.TopBar-searchPopup',
    wrapper: '.TopBar-searchPopup-wrapper',
    buttonMore: '.TopBar-searchPopup-more span'
};


const BindFunctions = [
    'onPopup',
    'onLoad',
    'onMore'
];

export default class TopBar extends Base {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.search}`]: this.onPopup,
            [`${VIEWPORT_EVENTS.click} ${Selectors.mobileSearch}`]: this.onMobileSearch,
            [`${VIEWPORT_EVENTS.click} ${Selectors.buttonMore}`]: this.onMore,
            [`${VIEWPORT_EVENTS.keyUp} ${Selectors.inputSearch}`]: this.onKeySearch
        };
    }

    constructor() {
        super({
            el: Selectors.el,
            VIEWS_TO_REGISTER: {'search-item': {selector: '.SearchItem', viewConstructor: SearchItem}}
        });
        _.bindAll(this, BindFunctions);

        this.urlPage = window.location.pathname
            .replaceAll('articles-search', 'articles')
            .replaceAll('/en')
            .split('/')[1];
        this.$moreContent = this.$(Selectors.wrapper);
        this.isData = false;
        this.count = 0;

        // closing the popup outside the element
        $(window.document).click(function (e) {
            if (!$(e.target).closest(Selectors.search).length && !$(e.target).closest(Selectors.mobileSearch).length) {
                $(Selectors.search).removeClass('open');
                $(Selectors.popupSearch).removeClass('open');
                app.els.$htmlBody.removeClass('disableScroll');
            }
        });
    }

    onPopup(e) {
        const $target = $(e.currentTarget);

        // load the first 14 to be shown in the popup from (search-preview-tokens)
        if (!$target.hasClass('open')) {
            // $target.addClass('open');
            // $target.children(Selectors.popupSearch).addClass('open');

            if (this.isData === false) {
                axios.get(Urls['front:api:' + this.urlPage + '-search-preview-tokens'](), {
                    params: {
                        loaded: this.count,
                        language: window.app.settings.language,
                        limit: 14
                    }
                }).then(response => {
                    this.onLoad(response?.data);
                    this.isData = true;
                });
            }
        }
    }

    onMobileSearch() {
        const $search = $(Selectors.search);
        const $searchPopup = $(Selectors.popupSearch);

        // load the first 14 to be shown in the popup from (search-preview-tokens)
        if (!$searchPopup.hasClass('open')) {
            $search.addClass('open');
            $searchPopup.addClass('open');
            app.els.$htmlBody.addClass('disableScroll');

            if (this.isData === false) {
                axios.get(Urls['front:api:' + this.urlPage + '-search-preview-tokens'](), {
                    params: {
                        loaded: this.count,
                        language: window.app.settings.language,
                        limit: 14
                    }
                }).then(response => {
                    this.onLoad(response?.data);
                    this.isData = true;
                });
            }
        }
    }

    onMore() {
        // load 42 records from (search-preview-tokens)
        axios.get(Urls['front:api:' + this.urlPage + '-search-preview-tokens'](), {
            params: {
                loaded: this.count,
                language: window.app.settings.language,
                limit: 42
            }
        }).then(response => {
            this.onLoad(response?.data);

            if (response?.data.length < 42) {
                this.$('.TopBar-searchPopup-more').addClass('hidden');
                this.$(Selectors.popupSearch).addClass('all');
            }
        });
    }

    onKeySearch(e) {
        if ($(e)[0].keyCode === 37 || $(e)[0].keyCode === 39) {
            return;
        }

        this.value = $(e.currentTarget)[0].value;
        if (this.value === '') {
            // reset the counter and clear the array to return to loading with pagination
            this.count = 0;
            this.$moreContent.children().remove();
            axios.get(Urls['front:api:' + this.urlPage + '-search-preview-tokens'](), {
                params: {
                    loaded: this.count,
                    language: window.app.settings.language,
                    limit: 14
                }
            }).then(response => {
                this.onLoad(response?.data);
                this.$('.TopBar-searchPopup-more').removeClass('hidden');
                this.$(Selectors.popupSearch).removeClass('all');
            });
        } else {
            // load everything by coincidence with value from input
            axios.get(Urls['front:api:' + this.urlPage + '-search-tokens'](), {
                params: {
                    value: String(this.value),
                    language: window.app.settings.language
                }
            })
                .then(response => {
                    this.onLoad(response?.data);
                    this.$('.TopBar-searchPopup-more').addClass('hidden');
                    this.$(Selectors.popupSearch).addClass('all');
                    this.$(Selectors.search).addClass('open');
                    this.$(Selectors.search).children(Selectors.popupSearch)
                        .addClass('open');
                })
                .catch(() => {
                    this.$moreContent.children().remove();
                });
        }
    }

    onLoad(data) {
        // collecting and rendering data for search
        if (data) {
            if (this.value) {
                this.$moreContent.children().remove();
            }
            for (let i = 0; i <= data.length && data[i] !== undefined; i++) {
                var $moreItems = $(SearchItemTemplate.render({
                    item: data[i],
                    language: window.app.settings.language,
                    mods: (this.urlPage === 'articles') ? this.urlPage + '-search' : this.urlPage
                }));

                this.$moreContent.append($moreItems);
            }

            this.count += data.length;

            if (this.$moreContent.data('length') <= this.count) {
                this.$more.addClass('hidden');
            }
        }
    }
};
